/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRaiFormPost } from '../fn/rai-form/api-rai-form-post';
import { ApiRaiFormPost$Params } from '../fn/rai-form/api-rai-form-post';
import { apiRaiFormRequestIdGet } from '../fn/rai-form/api-rai-form-request-id-get';
import { ApiRaiFormRequestIdGet$Params } from '../fn/rai-form/api-rai-form-request-id-get';

@Injectable({ providedIn: 'root' })
export class RaiFormService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRaiFormRequestIdGet()` */
  static readonly ApiRaiFormRequestIdGetPath = '/api/RAIForm/{requestId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaiFormRequestIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaiFormRequestIdGet$Response(params: ApiRaiFormRequestIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRaiFormRequestIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaiFormRequestIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaiFormRequestIdGet(params: ApiRaiFormRequestIdGet$Params, context?: HttpContext): Observable<void> {
    return this.apiRaiFormRequestIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRaiFormPost()` */
  static readonly ApiRaiFormPostPath = '/api/RAIForm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaiFormPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaiFormPost$Response(params?: ApiRaiFormPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRaiFormPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaiFormPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaiFormPost(params?: ApiRaiFormPost$Params, context?: HttpContext): Observable<void> {
    return this.apiRaiFormPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
